import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import ServiceRequestStepper from './ServiceRequestStepper';
import { serviceSelectorStepFactory } from './Steps/ServiceSelectorStep';
import { carSelectorStepFactory } from './Steps/CarSelectorStep';
import { locationSelectorStepFactory } from './Steps/LocationSelectorStep';
import { userSelectorStepFactory } from './Steps/UserSelectorStep';
import { parseSearch } from '../../../helpers/UrlHelper';
import { apiClient } from '../../../helpers/apiHelperV2';
import { toast } from '../../../helpers/toastHelper';
import { userSelector } from '../../../modules/selectors/auth';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { zipCodeStepFactory } from './Steps/ZipCodeStep';
import { useStandortHistory } from '../../components/VHost/StandortHistory';

const mapNewServiceAnfrageToOld = ({
    serviceUrl,
    serviceNotes,
    vehicleIdentificationNumber,
    carBrand,
    carModel,
    mileage,
    selectedSublocation,
    salutation,
    lastName,
    email,
    comment,
    zipCode,
}) => ({
    service: serviceUrl,
    serviceNotes,
    salutation,
    carnumber: vehicleIdentificationNumber,
    lastName,
    contact_email: email,
    carMake: carBrand,
    carModel,
    milage: mileage,
    desiredSchedule: comment,
    selectedLocation: selectedSublocation,
    zip: zipCode,
});

function ServiceRequestForm() {
    const { serviceUrl } = useParams();
    const location = useLocation();
    const history = useStandortHistory();
    const { anfrageText } = parseSearch(location.search);
    const validServiceUrl = serviceUrl || 'serviceAnfrage';
    const user = useSelector(userSelector);
    const standortUrl = useSelector(standortUrlSelector);
    const markenStandort = useSelector(markenStandortSelector);

    const steps = [
        serviceSelectorStepFactory({ validServiceUrl, anfrageText }),
        carSelectorStepFactory(),
        markenStandort.isTechno ? zipCodeStepFactory({ markenStandortId: markenStandort._id }) : locationSelectorStepFactory(),
        userSelectorStepFactory({ user }),
    ];

    const handleStepperSubmit = async newValues => {
        try {
            const oldValues = mapNewServiceAnfrageToOld(newValues);
            await apiClient.post('/api/v1/ServiceAnfrage', { processedAnfrage: oldValues, standortUrl: standortUrl });
            toast({ message: 'Ihre Serviceanfrage wurde erfolgreich übermittelt', status: 'success' });
            history.push('/');
        } catch (err) {
            toast({ err });
        }
    };

    return (
        <div className="uk-form">
            <ServiceRequestStepper onStepperSubmit={handleStepperSubmit} steps={steps} />
        </div>
    );
}

export default ServiceRequestForm;
